module.exports = __webpack_public_path__ + "media/examine.92131e51.mp3";